import { useAtom } from "jotai";
import { useCallback } from "react";

import { StoreConfetti } from "../store/store";

const CONFETTI_DURATION = 10000; // 3 seconds

/**
 * Hook for triggering confetti celebrations
 *
 * @example
 * ```tsx
 * const { celebrate } = useConfetti();
 *
 * // Trigger confetti
 * celebrate();
 * ```
 */
export const useConfetti = () => {
  const [confettiState, setConfettiState] = useAtom(StoreConfetti);

  const celebrate = useCallback(() => {
    setConfettiState({
      isActive: true,
      timestamp: Date.now(),
    });

    // Auto-stop after animation completes
    setTimeout(() => {
      setConfettiState((prev) => ({
        ...prev,
        isActive: false,
      }));
    }, CONFETTI_DURATION);
  }, [setConfettiState]);

  return {
    celebrate,
    isActive: confettiState.isActive,
  };
};
